export const PBGIDS = {
  ignore: [
    // Byzantines
    2122504, // chierosiphon (blueprint)

    // Japanese
    2138205, // uma banner dropped
    2138188, // katana banner dropped
    2138204, // yumi banner dropped

    // English
    202514,  // Wynguard Army spawner
    2075742, // Wynguard Raiders spawner
    2122352, // Wynguard Footman spawner
    2075743, // Wynguard Rangers spawner

    // Knights Templar
    5000301, // Pilgrim
    9002828, // Heavy Spearman (Ronin) spawner from PoI

  ],
  fallback: {
    // Ayyubids
    2132733: 6946920, // (free) desert Raider
    2132735: 2136952, // (free) elite desert raider
    2132734: 7844054, // (free) veteran desert raider
    2145897: 2762454, // (free) trader
    2146034: 2146044, // Bedouin Swordsman
    2146037: 2146020, // Bedouin Skirmisher
    2145896: 2144832, // (free) atabeg
    // 2160100: Missing Camel Rider Barding

    // Byzantines
    2140765: 2140764, // chierosiphon (workshop)
    2122503: 2140764, // chierosiphon (field constructed)

    2132800: 2146746, // eastern mercenary contract
    2118862: 2146757, // veteran mercenary contract upgrade
    2118863: 2146758, // elite mercenary contract upgrade
    2101237: 2101236, // aqcuaduct

    // English
    187692: 2133269, // set up camp
    2161903: 2104832, // king

    // Japanese
    2145966: 2127064, // veteran uma bannerman
    2145967: 2127064, // elite uma bannerman
    2143515: 2127061, // veteran yumi bannerman
    2143516: 2127061, // elite yumi bannerman
    2143513: 2143512, // veteran katana bannerman
    2143514: 2143512, // elite katana bannerman
    2127200: 2127199, // veteran onna bugeshia
    2127201: 2127199, // elite onna bugeshia
    2143839: 2124339, // (deployed) ozutsu
    2143867: 7319578, // (deployed) bombard
    2143863: 4137773, // (deployed) Handcannon Ashigaru
    2143869: 2143534, // (deployed) ribauldequin

    // Jeanne d'Arc
    2145718: 2144375, // enlistment incentives -> Ordinance company
    2035318: 170541, // cantled saddles
    2035321: 172158, // crossbow stirrups

    // Ottomans
    171001: 2136153 // great bombard emplacement
  }
}
